import { withGlobal } from "components/global/GlobalWrapper";
import BuildingUnitNew from "./BuildingUnitNew";
import { buildingStructuresReducers } from "components/stores/building_structures/reducers";

export default withGlobal(BuildingUnitNew, { reducers: buildingStructuresReducers });
